import { CIMSModule, CIMSPage, Permission } from '@cims-online/shared'
import { useProtectedMenuItem } from './useProtectedMenuItem'

export function useIFI() {
  return useProtectedMenuItem({
    module: CIMSModule.IFI,
    pages: [
      {
        page: CIMSPage.IFITracker,
        permission: Permission.ViewIdentifiedFieldIssue,
      },
      {
        page: CIMSPage.IFINotifications,
        permission: Permission.ViewIFINotification,
      },
    ],
  })
}
